/* Qik Joe — the heritage slideshow

   The history as a set of eras you move through, with the year timeline as the
   navigation. The rail idea survives the redesign: it stopped being a passive
   readout and became the control.

   Built as a tablist — years are tabs, eras are panels — because that is what
   this actually is, and it means arrow keys, Home and End work the way anyone
   using a keyboard already expects.

   No auto-advance. A slideshow that moves while you are reading it is a
   slideshow nobody finishes. */

(function () {
  'use strict';

  function Deck(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-era-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-era-panel]'));
    if (!this.tabs.length) return;

    this.prevBtn = root.querySelector('[data-era-prev]');
    this.nextBtn = root.querySelector('[data-era-next]');
    this.counter = root.querySelector('[data-era-counter]');
    this.progress = root.querySelector('[data-era-progress]');

    this.index = 0;
    var self = this;

    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.go(i, true); });
      tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index - 1, true); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index + 1, true); });

    this.bindSwipe();
    this.go(0, false);
  }

  Deck.prototype.onKey = function (event, i) {
    var last = this.tabs.length - 1;
    var next = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i >= last ? 0 : i + 1;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i <= 0 ? last : i - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = last;

    if (next === null) return;
    event.preventDefault();
    this.go(next, true);
    this.tabs[next].focus();
  };

  // Touch: a horizontal drag moves an era. Vertical drags are left alone so
  // the page still scrolls normally under a thumb.
  Deck.prototype.bindSwipe = function () {
    var self = this, x0 = null, y0 = null;

    this.root.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].clientX;
      y0 = e.changedTouches[0].clientY;
    }, { passive: true });

    this.root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      self.go(self.index + (dx < 0 ? 1 : -1), true);
    }, { passive: true });
  };

  Deck.prototype.go = function (i, announce) {
    var last = this.tabs.length - 1;
    if (i < 0) i = 0;
    if (i > last) i = last;
    this.index = i;

    for (var t = 0; t < this.tabs.length; t++) {
      var on = t === i;
      this.tabs[t].classList.toggle('is-current', on);
      this.tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      // Roving tabindex: one stop for the whole timeline, then arrow keys.
      this.tabs[t].setAttribute('tabindex', on ? '0' : '-1');
    }

    for (var p = 0; p < this.panels.length; p++) {
      this.panels[p].hidden = p !== i;
    }

    if (this.prevBtn) this.prevBtn.disabled = i === 0;
    if (this.nextBtn) this.nextBtn.disabled = i === last;
    if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.tabs.length;
    if (this.progress) {
      this.progress.style.setProperty('--era-progress', last ? (i / last) : 1);
    }

    if (announce) {
      var current = this.tabs[i];
      if (current && current.scrollIntoView) {
        current.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }
  };

  function init(root) {
    var decks = (root || document).querySelectorAll('[data-era-deck]');
    for (var i = 0; i < decks.length; i++) new Deck(decks[i]);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
